"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Iterator_1 = __importDefault(require("../../Maker/Iterator"));
exports.default = () => new Iterator_1.default([
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer molestie libero quam, ut rhoncus nulla lacinia eget. Morbi sit amet varius tellus. Donec vehicula lorem non vestibulum imperdiet.",
    "\n\nLorem ipsum dolor sit amet\nconsectetur adipiscing elit.\nInteger molestie libero quam,\nut rhoncus nulla lacinia eget. Morbi sit amet varius tellus.\nDonec vehicula lorem non vestibulum imperdiet.",
    "ok",
    "Lorem ipsum",
    "Lorem ipsum dolor sit amet\nconsectetur\nMorbi\nvarius",
]);
//# sourceMappingURL=getNoteIterator.js.map